module.exports = __webpack_public_path__ + "img/user_guide.8ca1bfe0.svg";